/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";

/* Styles */
import styles from "./styles";

const AssignModal = ({showModal, setShowModal, modalIcon, modalTitle, modalDescription, assignData, setAssignData, handleAssign, confirmButtonText, type, cardText, initialGroupData}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
      <UCModal
        className={ classes.assignModal }
        showModal={ showModal }
        setShowModal={ setShowModal }
        modalIcon={ modalIcon }
        modalTitle= { modalTitle }
        modalDescription={ modalDescription}
        modalContent={ 
          <Content 
            setShowModal={setShowModal} 
            handleSubmit={handleAssign} 
            assignData={assignData} 
            setAssignData={setAssignData} 
            confirmButtonText={confirmButtonText} 
            type={type}
            cardText={cardText}
            initialGroupData={initialGroupData}
          /> 
        }
        dataTestId="assignModal"
      />
  )
}

export default AssignModal;
